import React from 'react'
import PropTypes from 'prop-types'

import useStyles from './styles'

const AdAssetMediaPreview = ({ ad }) => {
  const classes = useStyles()

  const assetLink = ad?.assets[0]?.asset?.url

  if (!assetLink) {
    return null
  }

  return (
    <div className={classes.previewContainer}>
      <img className={classes.mediaPreview} src={assetLink} alt="Media asset preview" />
    </div>
  )
}

AdAssetMediaPreview.propTypes = {
  ad: PropTypes.object
}

export default AdAssetMediaPreview
